import pagoMisCuentasBanelco from '@/assets/pagomiscuentas.png';
import { Button, Divider, Loader } from '@/components';
import usePinsAccount from '@/hooks/usePinsAccount';
import { useGetInitMyaccount } from '@/modules/my-account/hooks/useMyAccount';

interface Props {
  isHowTo: boolean;
}

const GetPins = () => {
  const { pinsData } = usePinsAccount();
  const { data } = useGetInitMyaccount();
  if (!data) return <Loader isVisible={true} />;
  if (!('usuario' in data)) return null;
  const formatedDoc = String(data?.usuario?.nroDoc).padStart(8, '0');
  const docType = data?.usuario?.idTipoDoc;
  const productId = String(pinsData?.selectedProduct?.id ?? '02').padStart(
    2,
    '0'
  );
  const PMC = `0${productId}${docType}${formatedDoc}`;
  return (
    <>
      <li>
        Logueate en <strong>Pagomiscuentas.com</strong> con tu DNI y Clave.
      </li>
      <li>
        Seleccioná el rubro <strong>“Otros Servicios”</strong> y luego hacé
        click en <strong>“Gran DT”</strong>
      </li>
      <li>
        Allí deberás incluir el siguiente código de pago{' '}
        <strong className="text-gdt-blue">{PMC}.</strong>
      </li>
      <li>
        Finalmente ingresá, como monto a cargar, el precio exacto del pack que
        deseás comprar.
      </li>
      <li>
        En el transcurso de las próximas 2 horas tendrás acreditado tus pines en
        tu cuenta de Gran DT.
      </li>
    </>
  );
};

const HowTo = () => {
  return (
    <>
      <li>
        Logueate en <strong>Pagomiscuentas.com</strong> con tu DNI y Clave.
      </li>
      <li>
        Seleccioná el rubro <strong>“Otros Servicios”</strong> y luego hacé
        click en <strong>“Gran DT”</strong>
      </li>
      <li>Allí deberás incluir tu numero de DNI y monto a cargar</li>
      <li>
        En el transcurso de las próximas 2 horas tendrás acreditado tus pines en
        tu cuenta de Gran DT.
      </li>
    </>
  );
};

export const PayWithPagoMisCuentas = ({ isHowTo }: Props) => {
  return (
    <div className="flex flex-col mb-10">
      <p className="text-gdt-gray text-base font-bold mx-auto">
        {isHowTo ? 'Carga saldo desde' : 'Obtené tus pines con'}
      </p>
      <img
        alt="pago mis cuentas"
        className="w-44 mx-auto mt-3"
        src={pagoMisCuentasBanelco}
      />
      <Divider className="my-5 border-2" type="horizontal" />
      {isHowTo && <h4 className="font-bold mx-auto">¿Cómo cargar saldo?</h4>}
      <ol className="list-decimal font-normal px-6 mb-6">
        {isHowTo ? <HowTo /> : <GetPins />}
      </ol>
      <Button
        className="w-full mt-4"
        type="button"
        variant="primary"
        onClick={() => window.open('https://pagomiscuentas.com/', '_blank')}
      >
        Ir a Pago Mis Cuentas
      </Button>
    </div>
  );
};
